<template>
  <div class="utmTrackingInput">
    <el-form :model="utmForm" :rules="utmFormRules" ref="utmInputForm" :class="{ readOnly: readOnly === true }">
      <el-row :gutter="20">
        <el-col :span="24" style="padding-bottom: 10px">
          <el-checkbox v-if="!readOnly" v-model="enabled">Add UTM Tracking For Dynamic/Auto-Generated Fields</el-checkbox>
          <template v-else>
            <div v-if="!enabled" class="value">UTM tracking is not configured</div>
          </template>
        </el-col>
        <el-col v-if="enabled" :span="24" style="padding-top: 2px; padding-bottom: 15px">
          <el-checkbox :disabled="readOnly" v-model="overridePrams"> Over-write UTM details if already present in links. </el-checkbox>
          <div v-if="enabled" class="infoMessage" :span="24">UTM parameters will be added only for dynamic and auto-generated fields.</div>
        </el-col>
        <template v-if="enabled">
          <el-col :span="8">
            <el-form-item prop="campaign">
              <el-input size="small" placeholder="Enter UTM Campaign" v-model="utmForm.campaign" :disabled="readOnly">
                <template slot="prepend">UTM Campaign</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="source">
              <el-input size="small" placeholder="Enter UTM Source" v-model="utmForm.source" :disabled="readOnly">
                <template slot="prepend">UTM Source</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="medium">
              <el-input size="small" placeholder="Enter UTM Medium" v-model="utmForm.medium" :disabled="readOnly">
                <template slot="prepend">UTM Medium</template>
              </el-input>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
  </div>
</template>

<style lang="scss" src="./utmTrackingInput.scss"></style>

<script>
import utmTrackingInputComponent from './utmTrackingInputComponent';
export default utmTrackingInputComponent;
</script>
